<template>
    <div>
        <div class="container">
            <b-breadcrumb :items="breadcrumb" v-if="breadcrumb"></b-breadcrumb>

            <div class="row">
                <div class="d-none d-xl-block col-xl-3">
                    <catalog-categories></catalog-categories>
                </div>


                <div class="col-xl-9">

                    <div v-if="loading" class="loading-box">
                        <b-spinner></b-spinner>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>


<script>

    export default {
        data() {
            return {
                loading: true,

                breadcrumb: null,
            }
        },

        watch: {
            $route() {
                this.loading = true;
                this.init();
            },
        },

        mounted() {
            this.init()
        },

        methods: {
            init() {

                this.loading = false;
                this.getBreadcrumb();

                document.title = "Тестовое бронирование";
                let desc = 'Тестовое бронирование "MRental"';
                document.querySelector('meta[name="description"]').setAttribute("content",  desc);
                document.querySelector('meta[name="twitter:description"]').setAttribute("content",  desc);
                document.querySelector('meta[property="og:description"]').setAttribute("content",  desc);
                document.querySelector('meta[name="twitter:text:description"]').setAttribute("content",  desc);

            },

            getBreadcrumb() {
                this.breadcrumb = [
                    {
                        text: 'Главная',
                        to: {name: 'pages-index'}
                    },
                    {
                        text: "Тестовое бронирование",
                        active: true
                    }
                ]
            }
        }
    }
</script>

